module.exports = __webpack_public_path__ + "static/media/puzzle.0ad368f8.svg";